import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { CommonPagesService } from '../../common-pages.service';
import { FormService } from 'src/@services/form.service';
import { ResponseStatus } from '../../enum';
import { InnerPagesService } from 'src/app/pages/common-layout/inner-pages.service';

@Component({
  selector: 'app-add-update-retailprogram-emaildefaults',
  templateUrl: './add-update-retailprogram-emaildefaults.component.html',
  styleUrls: ['./add-update-retailprogram-emaildefaults.component.scss'],

  standalone: false,
})
export class AddUpdateRetailprogramEmaildefaultsComponent implements OnInit {
  isVisibleEmailsDrawer = true;
  @Input() selectedRetailProgramEmailDefault: any;
  @Output() hideEmailsDrawer = new EventEmitter();
  isLoadingOne = false;
  allChecked = false;
   canEditRetailProgram: Boolean = false;
  emailDefault: any = [];
  retailProgramsDefaultDrawerTitle: string = '';

  constructor(
    public _cs: CommonService,
    private _ws: CommonPagesService,
    public _fS: FormService,
    private _iS: InnerPagesService
  ) {}

  ngOnInit(): void {
    this._fS.retailProgramsForm_fb();

    if (this.selectedRetailProgramEmailDefault) {
      this.retailProgramsDefaultDrawerTitle =
        'Set Email Default (' + this.selectedRetailProgramEmailDefault.name + ')';

      this._fS.retailProgramsForm.patchValue({
        programName: this.selectedRetailProgramEmailDefault.name,
        isActiveRetailPrograms: this.selectedRetailProgramEmailDefault.isActive,
      });
      this.canEditRetailProgram = this._iS.canAccessRetailPrograms().canEditRetailPrograms;
      const rawDefaults = JSON.parse(
  JSON.stringify(this.selectedRetailProgramEmailDefault.emailDefault)
);

// Directly use raw structure
this.emailDefault = rawDefaults.map((group: any) => ({
  title: group.title,
  events: group.events.map((event: any) => ({
    subject: event.subject,
    triggerOn: event.triggerOn,
    remark: event.remark,
    isChecked: event.isChecked,
  })),
  isChecked: group.events.every((event: any) => event.isChecked),
}));



this.allChecked = this.emailDefault.every((group: any) => group.isChecked);

}}
  

      
// #region CheckUncheck
  updateAllChecked(): void {
    this.emailDefault.forEach((group: any) => {
      group.isChecked = this.allChecked;
      group.events.forEach((event: any) => (event.isChecked = this.allChecked));
    });
  }

  headerCheckUncheckAll(groupIndex: number, isChecked: boolean): void {
    const group = this.emailDefault[groupIndex];
    group.events.forEach((event: any) => (event.isChecked = isChecked));
  }

  subHeaderCheckUncheck(groupIndex: number, eventIndex: number, isChecked: boolean): void {
    const group = this.emailDefault[groupIndex];
    group.isChecked = group.events.every((e: any) => e.isChecked);
  }
// #endregion CheckUncheck

  handleOkEmailsDrawer() {
    this.isLoadingOne = true;

    const outputArray = this.emailDefault.flatMap((group: any) => ({
  title: group.title,
  events: group.events.map((event: any) => ({
    subject: event.subject,
    triggerOn: event.triggerOn,
    remark: event.remark,
    isChecked: event.isChecked,
  })),
}));
    

    const emailDefaultBody = {
      id: this.selectedRetailProgramEmailDefault.id,
      retailProgramDefaultAction: outputArray,
    };

    this._ws.UpdateRetailProgramEmailDefaults(emailDefaultBody).subscribe(
      (response: any) => {
        this.isLoadingOne = false;
        if (response.responseStatus == ResponseStatus.success) {
          this._cs.displayMessage('success', response.message);
          this.isVisibleEmailsDrawer = false;
          this.hideEmailsDrawer.emit({ hide: this.isVisibleEmailsDrawer, data: response.result });
        } else {
          this._cs.displayMessage('error', response.message);
        }
      },
      () => {
        this.isLoadingOne = false;
      }
    );
  }

  cancelEmailsDrawer() {
    this.isVisibleEmailsDrawer = false;
    this.hideEmailsDrawer.emit({ hide: this.isVisibleEmailsDrawer, data: null });
  }
}
